module.exports = __webpack_public_path__ + "static/media/HeyWow-SemiBold.843089b6.ttf";